import axios from 'axios';
import { responseGet, globalSettings, isUndNullEmp } from '../../helpers/settings';
import { buildingModelGet } from '../../models/buildings/building';

let result = {};
let dataObj = {};
let headerObj = {};
//let swalProperty = {};

//#region methods
//#region old code
// export const getApartamentsAsync = async (e = {}, buildingsId = '', userRole = '', setBuilding, buildings = [], apartments = [],
//     setBtnApartmentsSyncDisabled, setBtnApartmentsAddDisabled, auth = {}, setAliquotPercentage, setAssignedAliquot, setRemainingAliquot) => {
//     let response = responseGet();
//     try {
//         //#region initialize

//         setBuilding({});
//         setAssignedAliquot(0.00);
//         setRemainingAliquot(0.00);
//         setBtnApartmentsSyncDisabled(true);
//         setBtnApartmentsAddDisabled(true);

//         let localBuilding = {};
//         let localApartments = [];
//         let localIsEdit = false;
//         let localIsDelete = false;
//         let localRemainingAliquot = 0.00;
//         let localAssignedAliquot = 0.00; //localAliquotPercentageApartments
//         const localBuildingId = $(`#${buildingsId}`)?.val();
//         const localSubMethodName = 'Apartments / getApartamentsAsync';

//         //#endregion initialize

//         //#region data get

//         if (!isUndefined(localBuildingId) && !isNull(localBuildingId) && !isEmpty(localBuildingId)) {
//             localBuilding = buildings.filter(({ id }) => id === localBuildingId)[0];
//             if (!isUndefined(localBuilding) && !isNull(localBuilding) && !isEmpty(localBuilding)) {
//                 //#region old code

//                 // headerObj = {
//                 //     headers: {
//                 //         authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
//                 //     },
//                 // };
//                 // dataObj = {
//                 //     conditionals: [
//                 //         { field: globalSettings?.collections?.properties?.buildingId, operator: globalSettings?.react?.firebase?.operators?.equalTo, value: `${localBuildingId}` }
//                 //     ],
//                 //     ordersBy: [
//                 //         { field: globalSettings?.collections?.properties?.floor, value: 'asc', },
//                 //         { field: globalSettings?.collections?.properties?.identifier, value: 'asc', },
//                 //     ],
//                 //     buildingId: localBuildingId,
//                 // };

//                 // //result = await axios?.post(`${globalSettings?.app?.backend?.urlDev}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlApartments}/`, dataObj, headerObj);
//                 // result = await axios?.post(`${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlApartments}/`, dataObj, headerObj);
//                 // response = result.data;

//                 // if (!response?.isSuccess || response?.isWarning) {
//                 //     return response;
//                 // }

//                 //#endregion old code

//                 response = await apartamentsGetAsync(
//                     auth,
//                     localBuildingId,
//                     'getApartamentsAsync'
//                 );
//                 if (!response?.isSuccess || response?.isWarning) {
//                     return response;
//                 }

//                 localApartments = response.result;
//                 if (!isUndefined(localApartments) && !isNull(localApartments) && localApartments.length > 0) {
//                     map(localApartments, (detail) => {
//                         //#region set apartment data

//                         apartments.push([
//                             detail.identifier,
//                             detail.floor,
//                             detail.phoneNumber,
//                             buttonProcessGet(
//                                 detail.id,
//                                 detail.identifier,
//                                 true,
//                                 globalSettings?.labels?.detail.es,
//                                 processEvaluateGet(detail, globalSettings?.labels?.process?.en?.toLowerCase(), globalSettings?.labels?.detail.en.toLowerCase(), localSubMethodName).result,
//                                 true,
//                                 globalSettings?.labels?.edit.es,
//                                 processEvaluateGet(detail, globalSettings?.labels?.process?.en?.toLowerCase(), globalSettings?.labels?.edit?.en?.toLowerCase(), localSubMethodName).result,
//                                 true,
//                                 globalSettings?.labels?.delete.es,
//                                 processEvaluateGet(detail, globalSettings?.labels?.process?.en?.toLowerCase(), globalSettings?.labels?.delete?.en?.toLowerCase(), localSubMethodName).result,
//                                 []
//                             ).result
//                         ]);

//                         //#endregion set apartment data

//                         //#region calculate aliquot percentage

//                         if (isUndefined(detail.aliquotPercentage) || isNull(detail.aliquotPercentage)) {
//                             detail.aliquotPercentage = 0.00;
//                         }

//                         //#region old code

//                         //localAssignedAliquot += detail.aliquotPercentage;
//                         //localAssignedAliquot = numberSet(localAssignedAliquot, 'd').result + numberSet(detail.aliquotPercentage, 'd').result;
//                         //console.log({localAssignedAliquot, apartment: detail.aliquotPercentage});

//                         //#endregion old code
//                         localAssignedAliquot = numberSet((localAssignedAliquot + detail.aliquotPercentage), 'd').result;

//                         //#endregion calculate aliquot percentage
//                     });

//                     //#region set values aliquot percentage

//                     localAssignedAliquot = numberSet(localAssignedAliquot, 'd').result;
//                     localRemainingAliquot = numberSet((100.00 - localAssignedAliquot), 'd').result;
//                     setAssignedAliquot(localAssignedAliquot);
//                     setRemainingAliquot(localRemainingAliquot);

//                     //#endregion set values aliquot percentage

//                     //#region check if add register is enabled

//                     localIsEdit = processEvaluateGet(
//                         localApartments[0],
//                         globalSettings?.labels?.process?.en?.toLowerCase(),
//                         globalSettings?.labels?.edit?.en?.toLowerCase(),
//                         localSubMethodName
//                     ).result;
//                     localIsDelete = processEvaluateGet(
//                         localApartments[0],
//                         globalSettings?.labels?.process?.en?.toLowerCase(),
//                         globalSettings?.labels?.edit?.en?.toLowerCase(),
//                         localSubMethodName
//                     ).result;

//                     //#endregion check if add register is enabled
//                 } else {
//                     //#region check if add register is enabled

//                     localIsEdit = processEvaluateGet(
//                         localBuilding,
//                         globalSettings?.labels?.process?.en?.toLowerCase(),
//                         globalSettings?.labels?.edit?.en?.toLowerCase(),
//                         localSubMethodName
//                     ).result;

//                     localIsDelete = localIsEdit;

//                     //#endregion check if add register is enabled
//                 }

//                 //#region set aliquot percentage

//                 setAliquotPercentage(localBuilding.settings.accountsReceivable.aliquotPercentage);

//                 //#endregion set aliquot percentage
//             }
//             setBuilding(localBuilding);
//             setBtnApartmentsSyncDisabled(false);
//             setBtnApartmentsAddDisabled(!(localIsEdit && localIsDelete));
//         }

//         //#endregion data get
//     } catch (ex) {
//         response.isSuccess = false;
//         response.msgType = -1;
//         response.msgText = `Method: getApartamentsAsync<br/>`;
//         response.msgText += `Error: ${ex?.message}`;
//     }
//     return response;
// }
//#endregion old code

export const apartamentsGetAsync = async ({ buildingId = '', auth = {}, languageId = 'en', subMethod = '', }) => {
    const currentMethod = 'apartamentsGetAsync';
    let response = responseGet();
    try {
        headerObj = {
            headers: {
                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            },
        };
        dataObj = {
            conditionals: [
                { field: globalSettings?.collections?.properties?.buildingId, operator: globalSettings?.react?.firebase?.operators?.equalTo, value: `${buildingId}` }
            ],
            ordersBy: [
                { field: globalSettings?.collections?.properties?.floor, value: 'asc', },
                { field: globalSettings?.collections?.properties?.identifier, value: 'asc', },
            ],
            buildingId: buildingId,
            languageId: languageId,
            url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlApartments}/`,
        };

        result = await axios?.post(
            dataObj?.url,
            dataObj,
            headerObj,
        );

        response = result?.data;

        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

//#region old code
// export const deleteGetAsync = async (id = '', description = '', rowIndex = 0, dtApartmentsId = '', auth = {}, processValues = {}) => {
//     let response = responseGet();
//     try {
//         console.log({processValues});
//         return;

//         //#region variables

//         let localApartment = {};
//         let localAssignedAliquot = 0.00;
//         let localRemainingAliquot = 0.00;

//         //#endregion variables

//         //#region show message

//         swalProperty = {
//             icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
//             title: globalSettings?.messages?.areYouSureDeleteThis.es,
//             html: `${globalSettings?.labels?.apartment.es}: <b>${description}</b><br/>${globalSettings?.messages?.thisProcessIrreversibleDoYouWishContinue.es}`,
//             timer: null,
//             confirmButtonColor: globalSettings?.colors?.warningColorExp,
//             confirmButtonText: globalSettings?.labels?.yes.es,
//             showCancelButton: true,
//             cancelButtonColor: globalSettings?.colors?.successColorExp,
//             cancelButtonText: globalSettings?.labels?.no.es,
//             didOpen: () => {
//                 Swal.hideLoading();
//             },
//         };

//         const { isConfirmed, } = await Swal.fire(swalProperty);

//         //#endregion show message

//         //#region delete data

//         if (isConfirmed) {
//             sendMessage(2, globalSettings?.messages?.processing.es, globalSettings?.timers?.thirtySeconds, false, true, null, '');

//             headerObj = {
//                 headers: {
//                     authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
//                 },
//             };

//             result = await axios.delete(`${globalSettings?.app?.backend?.urlDev}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlApartments}/${id}`, headerObj);
//             //result = await axios.delete(`${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlApartments}/${id}`, headerObj);
//             response = result.data;

//             if (!response?.isSuccess || response?.isWarning) {
//                 await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
//                 return;
//             }

//             localApartment = response.result;

//             $(`#${dtApartmentsId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);

//             if (!isUndefined(localApartment) && !isNull(localApartment) && !isEmpty(localApartment)) {
//                 if (!isUndefined(localApartment.aliquotPercentage) && !isNull(localApartment.aliquotPercentage)) {

//                     console.log({processValues, localApartment});

//                     // localAssignedAliquot = numberSet((processValues.assignedAliquot - localApartment.aliquotPercentage), 'd').result;
//                     // localRemainingAliquot = numberSet((100.00 - localAssignedAliquot), 'd').result;
//                     // processValues.setAssignedAliquot(localAssignedAliquot);
//                     // processValues.setRemainingAliquot(localRemainingAliquot);
//                 }
//             }

//             sendMessage(0, globalSettings?.messages?.processesCompletedSuccessfully.es, 0, true, false, null, '');
//         }

//         //#endregion delete data
//     } catch (ex) {
//         response.isSuccess = false;
//         response.msgType = -1;
//         response.msgText = `Method: deleteGet<br/>`;
//         response.msgText += `Error: ${ex?.message}`;
//         await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
//     }
//     return response;
// }
//#endregion old code
//#endregion methods

//#region methods (others)
//#region old code
// export const dataTablesSet = (dtApartmentsId = '') => {
//     let response = responseGet();
//     try {
//         $(`#${dtApartmentsId}`)?.DataTable({
//             //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
//             columns: [
//                 { title: globalSettings?.labels?.identifier.es, width: '60%', },
//                 { title: globalSettings?.labels?.floor.es, width: '15%', },
//                 { title: globalSettings?.labels?.phone.es, width: '20%', },
//                 { title: globalSettings?.labels?.process.es, className: 'text-center', width: '5%', orderable: false, searchable: false, },
//             ],
//             data: [],
//             destroy: true,
//             language: dataTableLanguaje('es'),
//             order: [[1, 'asc'], [0, 'asc']],
//             responsive: true,
//             lengthChange: true,
//             autoWidth: false,
//             //}).buttons().container().appendTo(`#${dtApartmentsId}_wrapper .col-md-6:eq(0)`);
//         });
//     } catch (ex) {
//         response.isSuccess = false;
//         response.msgType = -1;
//         response.msgText = `Method: dataTablesSet<br/>`
//         response.msgText += `Error: ${ex?.message}`
//     }
//     return response;
// }

// export const queryCodeSet = (dtApartmentsId = '', auth = {}, processValues = {}) => {
//     let response = responseGet();
//     try {
//         //#region variables

//         let localRowIndex = 0;
//         let localDtRowIndex = 0;
//         let localAttribute = {};
//         let localMethodValue = '';
//         let localId = '';
//         let localDescription = '';

//         //#endregion variables

//         $(`#${dtApartmentsId} tbody`)?.on('click', 'tr', 'td', async function (e) {
//             e.preventDefault();
//             localRowIndex = $(`#${dtApartmentsId}`)?.DataTable()?.row(this)?.index();
//             localDtRowIndex = (!isUndefined(localRowIndex) ? localRowIndex : localDtRowIndex);
//             if (!isUndefined(localDtRowIndex)) {
//                 localAttribute = e.target.attributes.method;
//                 localMethodValue = localAttribute === undefined ? '' : localAttribute.value;
//                 localId = isUndefined(e.target.attributes.id) ? '' : e.target.attributes.id.value;
//                 localDescription = isUndefined(e.target.attributes.description) ? '' : e.target.attributes.description.value;
//                 switch (localMethodValue) {
//                     case 'edit':
//                         window.location.href = `${globalSettings?.app?.backend?.urlApartmentEdit}/${localId}`;
//                         break;
//                     case 'details':
//                         window.location.href = `${globalSettings?.app?.backend?.urlApartmentDetails}/${localId}`;
//                         break;
//                     case 'delete':
//                         deleteGetAsync(
//                             localId,
//                             localDescription,
//                             localDtRowIndex,
//                             dtApartmentsId,
//                             auth,
//                             processValues,
//                         );
//                         break;
//                     default:
//                         break;
//                 }
//             }
//         });
//     } catch (ex) {
//         response.isSuccess = false;
//         response.msgType = -1;
//         response.msgText = `Method: queryCodeSet<br/>`
//         response.msgText += `Error: ${ex?.message}`
//     }
//     return response;
// }
//#endregion old code

export const buildingFloorsGet = ({ building = buildingModelGet({}), setBuildingFloors = () => { }, languageId = 'en', subMethod = '', }) => {
    const currentMethod = 'buildingFloorsGet';
    let response = responseGet();
    try {
        let buildingFloors = [];
        if (!isUndNullEmp({ data: building, subMethod: currentMethod, })?.result) {
            if (building?.lowLevel > 0 || building?.floors > 0 || building?.topLevel > 0) {
                if (building?.lowLevel) {
                    buildingFloors?.push({ label: 'PB', value: 0, });
                }

                if (building?.floors > 0) {
                    for (let index = 0; index < building?.floors; index++) {
                        buildingFloors?.push({ label: `${globalSettings?.labels?.floor?.[languageId]} ${index + 1}`, value: index + 1, });
                    }
                }

                if (building?.topLevel && building?.floors > 0) {
                    buildingFloors?.push({ label: 'PH', value: (building.floors + 1), });
                }
            } else {
                response.msgType = 1;
                response.isWarning = true;
                //response.msgText = `${globalSettings?.messages?.youMustDefineAtLeastOneFloorOfTheBuilding?.[languageId]}.`;
                response.msgText = `${globalSettings?.messages?.youMustDefineAtLeastOneFloorOfTheBuilding?.[languageId]}<br/>`;
                response.msgText += `${globalSettings?.messages?.goTo?.[languageId]}: <i class='${globalSettings?.icons?.buildingFa}'></i> `;
                response.msgText += `<a href='${globalSettings?.app?.backend?.urlBuildings}'>${globalSettings?.labels?.building?.[languageId]}</a>`;
            }
            setBuildingFloors(buildingFloors);
        }
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}
//#endregion methods (others)